import { IDependenciesRecord } from '../../../ModuleStore/interfaces/IDependencies';

export const COMMON_ALWAYS_REQUIRED_MODULES: IDependenciesRecord = {
    // TODO: [🏈] Maybe just remove and move/spread to COMMON_BOARD_REQUIRED_MODULES or COMMON_WELCOME_REQUIRED_MODULES
    // TODO: [🏈] Go through all of the modules
    RemoteAnnouncements: {
        /* [🏈] Use DEFAULT_ACTIVE_MODULE*/
    },
};
